/* eslint-disable no-plusplus */
// For Production
export const MONGO_DB_URI =
  process.env.NODE_ENV === "production"
    ? "mongodb://seomongo1.mmt.mmt,seomongo2.mmt.mmt,seomongo3.mmt.mmt:27017/?replicaSet=m_hlp_mgdb_dbs&readPreference=secondaryPreferred"
    : "mongodb://172.16.211.122:27017/";
export const MONGO_DB_NAME = process.env.NODE_ENV === "production" ? "seocms" : "seo_cms25042023";

export const HOST_NAME =
  process.env.NODE_ENV === "production"
    ? "https://www.makemytrip.com"
    : "http://10.212.53.25:8080/cmsbolt";
// For Staging
// export const MONGO_DB_URI = "mongodb://172.16.211.122:27017/";
// export const MONGO_DB_NAME = "seo_cms25042023";
export const IS_PROD = process.env.NODE_ENV === "production";

export const ABSOLUTE_URL_LANDING_PAGE = "https://www.makemytrip.com/flights/";
export const BASE_URL = "//www.makemytrip.com";
export const GI_BASE_URL = "//www.goibibo.com";
export const URL_LANDING_PAGE = "https://www.makemytrip.com";
export const BASE_DOMAIN = "www.makemytrip.com";
export const FLIGHTS_UI_FQDN = IS_PROD ? "http://flights-ui-seo.ecs.mmt/" : "http://localhost/";
export const FLIGHTS_CB = "https://flights-cb.makemytrip.com";
export const FLIGHTS_CB_GOIBIBO = "https://flights-cb.goibibo.com";
export const FLIGHTS_CB_GLOBAL = "https://flights-cb.makemytrip.global";
export const FLIGHTS_CB_SERVER = "http://flights-cbackend.ecs.mmt";
export const FLIGHTS_CB_SERVER_GLOBAL = "http://flights-overseas-cbackend-global.uae.mmt";
export const FLIGHTS_CB_SERVER_GOIBIBO = "http://flights-cbackend-gi.ecs.mmt";

// export const API_PREFIX = 'http://localhost:3000/api/';
export const API_PREFIX = `http://${process.env.HOST}:${process.env.PORT}/api/`;
export const AEO_CONTENT = "http://flights-aeo.ecs.mmt/flights-aeo/generate-faq";

export const API_FLIGHT_LISTING = `${FLIGHTS_CB}/api/search-dt?cc=E&cmpId=SEO&creditShellInfo=&forwardFlowRequired=true&pax=A-1_C-0_I-0&shd=true&sortBy=rhino&src=&`;
// export const API_OFFER_LISTING = "https://hcs-promo.makemytrip.com/makemytrip/promov3/desktop/5.8.3/query?";
export const API_OFFER_LISTING =
  "http://hcs-promo.makemytrip.com/makemytrip/promov3/desktop/desktop/query?";

export const API_FETCH_CITIES = `${FLIGHTS_CB}/api/flights-search/autosuggest?`;
export const EXPLORER_API = "https://flights-explorer.makemytrip.com/autosuggest";

export const EDIT_BUTTON =
  "https://imgak.mmtcdn.com/flights/assets/media/mobile/common/xhdpi/edit_icon.png";

export const API_FARE_CALENDAR = `${FLIGHTS_CB}/api/fareCalendar?`;
export const BASE_TEMPLATE = "baseTemplate";

export const MOBILE = "mobile";
export const DESKTOP = "desktop";
export const IS_MOBILE_BLOCK = "is_mobile_block";

export const APPCONFIG = "appConfig";
export const GET = "GET";
export const LOCALE = "LOCALE";
export const PRECONFIGURED = "PRECONFIGURED";
export const CUSTOMHTML = "CUSTOMHTML";
export const TEXT_TO_LINK_MAPPING = "text_to_link_mapping";
export const DESKTOP_DEVICE = "desktop";
export const MOBILE_DEVICE = "mobile";
export const REQUEST_PARAM_CMP = "cmp";
export const DEVICE = "device";
export const HINDI_STATIC_WIDGET_DT = "hiStaticSeoWidget.js";
export const HINDI_STATIC_WIDGET_PWA = "hiStaticSeoWidgetMob.js";
export const STATIC_WIDGET_DT = "staticSeoWidget.js";
export const STATIC_WIDGET_PWA = "staticSeoWidgetMob.js";
export const CACHE_PREFIX_DF_MOB_UNIF = "DF_ISM_MOB_UNIF:";
export const CACHE_PREFIX_DF_MOB_UNIF_GI = "GI_DF_ISM_MOB_UNIF:";
export const CACHE_PREFIX_IF_MOB_UNIF = "IF_ISM_MOB_UNIF:";
export const CACHE_PREFIX_IF_MOB_UNIF_GI = "GI_IF_ISM_MOB_UNIF:";
export const CACHE_PREFIX_IF_UNIF = "IF_ISM_UNIF:";
export const CACHE_PREFIX_DF_UNIF = "DF_ISM_UNIF:";
export const CACHE_PREFIX_DF_UNIF_GI = "GI_DF_ISM_UNIF:";
export const CACHE_PREFIX_IF_UNIF_GI = "GI_IF_ISM_UNIF:";
export const CACHE_PREFIX_DESTINATION_PICKER_PWA = "IF_DP_ISM_PWA_UNIF:";
export const CACHE_PREFIX_DESTINATION_PICKER_PWA_GI = "GI_IF_DP_ISM_PWA_UNIF:";
export const CACHE_PREFIX_DESTINATION_PICKER_DT = "IF_DP_ISM_DT_UNIF:";
export const CACHE_PREFIX_DESTINATION_PICKER_DT_GI = "GI_IF_DP_ISM_DT_UNIF:";
export const CACHE_PREFIX_FARE_FINDER_MOB = "FARE_FINDER_MOB:";
export const CACHE_PREFIX_FARE_FINDER_MOB_GI = "GI_FARE_FINDER_MOB:";
export const CACHE_PREFIX_FARE_FINDER_DT = "FARE_FINDER_DT:";
export const CACHE_PREFIX_FARE_FINDER_DT_GI = "GI_FARE_FINDER_DT:";
export const CACHE_PREFIX_FARE_CALENDAR = "FARE_CALENDAR:";
export const CACHE_PREFIX_FARE_CALENDAR_GI = "GI_FARE_CALENDAR:";

export const cachePrefixMapListing = {
  mobile: {
    goibibo: {
      intl: CACHE_PREFIX_IF_MOB_UNIF_GI,
      domestic: CACHE_PREFIX_DF_MOB_UNIF_GI,
    },
    default: {
      intl: CACHE_PREFIX_IF_MOB_UNIF,
      domestic: CACHE_PREFIX_DF_MOB_UNIF,
    },
  },
  desktop: {
    goibibo: {
      intl: CACHE_PREFIX_IF_UNIF_GI,
      domestic: CACHE_PREFIX_DF_UNIF_GI,
    },
    default: {
      intl: CACHE_PREFIX_IF_UNIF,
      domestic: CACHE_PREFIX_DF_UNIF,
    },
  },
};

export const cachePrefixMapDestinationPicker = {
  mobile: {
    goibibo: CACHE_PREFIX_DESTINATION_PICKER_PWA_GI,
    default: CACHE_PREFIX_DESTINATION_PICKER_PWA,
  },
  desktop: {
    goibibo: CACHE_PREFIX_DESTINATION_PICKER_DT_GI,
    default: CACHE_PREFIX_DESTINATION_PICKER_DT,
  },
};

export const cachePrefixMapFareFinder = {
  mobile: {
    goibibo: CACHE_PREFIX_FARE_FINDER_MOB_GI,
    default: CACHE_PREFIX_FARE_FINDER_MOB,
  },
  desktop: {
    goibibo: CACHE_PREFIX_FARE_FINDER_DT_GI,
    default: CACHE_PREFIX_FARE_FINDER_DT,
  },
};

export const cachePrefixMapFareCalendar = {
  goibibo: CACHE_PREFIX_FARE_CALENDAR_GI,
  default: CACHE_PREFIX_FARE_CALENDAR,
};

export const LISTING_INFO = "listingInfo";
export const PATH_VAR_LANGUAGE = "pathVarLanguage";
export const PATH_VAR_COUNTRY_CODE = "pathVarCountryCode";
export const AE_COUNTRY_CODE_URL_REDIRECT = "ae";
export const CURRENT_DOMAIN_NAME = "currentDomainName";

export const STATIC_PAGES_TEMPLATE = "static_pages_template";
export const TEMPLATE_TYPE = "template_type";
export const DFTemplate = "DFTemplate";
export const IFTemplate = "IFTemplate";
export const DF_OFFER_TEMPLATE = "df_offer_template";
export const DF_DISTANCE_TEMPLATE = "df_distance_template";
export const IF_DISTANCE_TEMPLATE = "if_distance_template";
export const DF_SEM_TEMPLATE = "df_sem_template";
export const IF_OFFER_TEMPLATE = "if_offer_template";
export const IF_OFFER_TEMPLATE_UNITED_ARAB_EMIRATES = "if_offer_template_united_arab_emirates";
export const HI_DF_OFFER_TEMPLATE = "hi_df_offer_template";
export const AR_IF_OFFER_TEMPLATE_UNITED_ARAB_EMIRATES =
  "ar_if_offer_template_united_arab_emirates";
export const DF_FARE_CALENDAR_TEMPLATE = "df_fare_calendar_template";
export const DF_AIRLINE_TEMPLATE = "df_airline_template";
export const CITY_AIRPORT_TEMPLATE = "city_airport_template";
export const IF_FARE_CALENDAR_TEMPLATE = "if_fare_calendar_template";
export const IF_FARE_CALENDAR_TEMPLATE_UNITED_ARAB_EMIRATES =
  "if_fare_calendar_template_united_arab_emirates";
export const DF_ROUTE_TEMPLATE = "df_route_template";
export const DF_ROUTE_AIRLINE_TEMPLATE = "df_route_airline_template";
export const HI_DF_AIRLINE_ROUTE_TEMPLATE = "hi_df_route_airline_template";
export const DF_AIRLINE_ROUTE_TEMPLATE = "df_route_airline_template";
export const IF_ROUTE_AIRLINE_TEMPLATE = "if_route_airline_template";
export const IF_ROUTE_AIRLINE_TEMPLATE_UNITED_ARAB_EMIRATES =
  "if_route_airline_template_united_arab_emirates";
export const IF_CITY_CITY_TEMPLATE = "if_city_city_template";
export const IF_CITY_CITY_TEMPLATE_UNITED_ARAB_EMIRATES =
  "if_city_city_template_united_arab_emirates";
export const DF_CITY_TEMPLATE = "df_city_template";
export const AIRLINE_TEMPLATE = "airline_template";
export const CITY_AIRLINE_TEMPLATE = "city_airline_template";
export const IF_CITY_AIRLINE_TEMPLATE = "if_city_airline_template";
export const IF_CITY_AIRLINE_TEMPLATE_UNITED_ARAB_EMIRATES =
  "if_city_airline_template_united_arab_emirates";
export const IF_CITY_TEMPLATE = "if_city_template";
export const IF_CITY_TEMPLATE_UNITED_ARAB_EMIRATES = "if_city_template_united_arab_emirates";
export const FLIGHT_SCHEDULE_TEMPLATE = "flight_schedule_template";
export const IF_FLIGHT_SCHEDULE_TEMPLATE = "if_flight_schedule_template";
export const IF_FLIGHT_SCHEDULE_TEMPLATE_UNITED_ARAB_EMIRATES =
  "if_flight_schedule_template_united_arab_emirates";
export const IF_COUNTRY_CITY_TEMPLATE = "if_country_city_template";
export const IF_CITY_COUNTRY_TEMPLATE = "if_city_country_template";
export const IF_CITY_CONTINENT_TEMPLATE = "if_city_continent_template";
export const IF_AIRLINE_INDEX_TEMPLATE = "if_airline_index_template";
export const IF_AIRLINE_TEMPLATE = "if_airline_template";
export const IF_AIRPORT_TEMPLATE = "if_airport_template";
export const IF_CITY_AIRLINE_INDEX_TEMPLATE = "if_city_airline_index_template";
export const IF_CITY_CITY_AIRLINE_INDEX_TEMPLATE = "if_city_city_airline_index_template";
export const HI_AIRLINE_INDEX_TEMPLATE = "hi_airline_index_template";
export const AIRLINE_INDEX_TEMPLATE = "airline_index_template";
export const IF_CITY_AIRPORT_INDEX_TEMPLATE = "if_city_airport_index_template";
export const IF_CITY_CITY_INDEX_TEMPLATE = "if_city_city_index_template";
export const IF_CITY_COUNTRY_INDEX_TEMPLATE = "if_city_country_index_template";
export const IF_CITY_INDEX_TEMPLATE = "if_city_index_template";

export const TOKENS = "tokens";
export const LOB = "lob";
export const BLOCK = "block";
export const BLOCK_TITLE = "blockTitle";
export const BLOCK_LIST = "blockList";
export const BLOCK_TEMPLATE = "blockTemplate";
export const AIRLINE = "airline";
export const ENTITY_TYPE_AIRLINE = "airline";
export const INTL_AIRLINE = "intl_airline";
export const INTL_AIRPORT = "intl_airport";
export const AIRPORT = "airport";
export const INTL_CITY = "intl_city";
export const INTERNATIONAL_CITIES = "internationalCities";
export const CITY = "city";
export const COUNTRY = "country";
export const INTL_COUNTRY = "intl_country";
export const ENTITY_TYPE_COUNTRY = "Country";
export const URL_CURRENT = "current_url";
export const IS_HERCULEAN = "isHerculean";
export const TEMPLATE = "template";
export const IS_STATIC_PAGE = "isStaticPage";
export const PATH_VAR_ALPHA = "pathVarAlpha";
export const PATH_VAR_ALPHA_DIGIT = "pathVarAlphaDigit";
export const DFROUTE = "dfroutes";
export const ROUTE_DISTANCE = "route_distance";
export const DOM_COUNTRY = "india";
export const DF_AIRLINE_ROUTE_OBJECT = "df_airline_routes";
export const JS_SETTINGS = "jsSettings";
export const AJAX_BLOCK_LIST = "ajaxBlockList";

export const URL_ATTRIBUTE_CITY = "urlAttributeCity";
export const URL_ATTRIBUTE_SRC = "urlAttributeSrc";
export const URL_ATTRIBUTE_DEST = "urlAttributeDest";
export const URL_ATTRIBUTE_AIRLINE = "urlAttributeAirline";
export const URL_ATTRIBUTE_CITY_COUNTRY_SRC = "urlAttributeCityCountrySrc";
export const URL_ATTRIBUTE_CITY_COUNTRY_DEST = "urlAttributeCityCountryDest";
export const URL_ATTRIBUTE_COUNTRY = "urlAttributeCountry";
export const URL_ATTRIBUTE_AIRPORT_CODE = "urlAttributeAirportCode";
export const URL_ATTRIBUTE_AIRPORT = "urlAttributeAirport";
export const URL_REDIRECT = "redirectUrl";

export const TOKEN_COUNTRY_FOLDER_CODE = "country_folder_code";
export const TOKEN_CURRENCY_CODE = "currency_code";
export const USER_CURRENCY = "userCurrency";
export const REGION = "region";
export const TOKEN_SRC_CITY_CODE = "src_city_code";
export const TOKEN_DES_CITY_CODE = "dest_city_code";
export const TOKEN_SRC_CITY_NAME = "src_city_name";
export const TOKEN_DES_CITY_NAME = "dest_city_name";
export const TOKEN_SRC_COUNTRY_NAME = "src_country_name";
export const TOKEN_DES_COUNTRY_NAME = "dest_country_name";
export const TOKEN_SRC_CITY_URL = "src_url_phrase";
export const TOKEN_DES_CITY_URL = "dest_url_phrase";
export const TOKEN_DEST_CITY_URL = "dest_url_phrase";
export const TOKEN_DES_CONTINENT_NAME = "dest_continent_name";
export const TOKEN_DES_CONTINENT_CODE = "dest_continent_code";
export const TOKEN_ABOUT_SRC_CITY = "about_src_city";
export const TOKEN_ABOUT_DEST_CITY = "about_dest_city";
export const TOKEN_SRC_CITY_AIRPORT_NAME = "src_city_airport_name";
export const TOKEN_DEST_CITY_AIRPORT_NAME = "dest_city_airport_name";
export const TOKEN_SRC_CITY_AIRPORT_DESCRIPTION = "src_city_airport_description";
export const TOKEN_DEST_CITY_AIRPORT_DESCRIPTION = "dest_city_airport_description";
export const TOKEN_SRC_CITY_AIRPORT_CODE = "source_city_airport_code";
export const TOKEN_DEST_CITY_AIRPORT_CODE = "destination_city_airport_code";
export const TOKEN_HI_SRC_CITY_NAME = "hi_src_city_name";
export const TOKEN_AIRLINE_NAME = "airline_name";
export const TOKEN_AR_AIRLINE_NAME = "ar_airline_name";
export const TOKEN_AIRLINE_DESCRIPTION = "airline_description";
export const TOKEN_AIRLINE_HISTORY = "airline_history";
export const TOKEN_AIRLINE_INFLIGHT_SERVICES = "inflight_services";
export const TOKEN_AIRLINE_AL_URL_PHRASE = "airline_al_url_phrase";
export const TOKEN_AIRLINE_CODE_LOWER_CASE = "airline_code_lower_case";
export const TOKEN_AIRLINE_URL_PHRASE = "airline_url_phrase";
export const TOKEN_AIRLINE_CHEAPEST_FARE_DATE = "airline_cheapest_date";
export const TOKEN_AIRLINE_CHEAPEST_PRICE = "airline_cheapest_price";
export const TOKEN_AIRLINE_CHEAPEST_ROUTE_SRC = "airline_cheapest_route_src";
export const TOKEN_AIRLINE_CHEAPEST_ROUTE_DEST = "airline_cheapest_route_dest";
export const TOKEN_AIRLINE_TOTAL_ROUTES = "airline_total_routes";
export const TOKEN_HI_CITY_NAME = "hi_city_name";
export const TOKEN_CITY_CODE = "city_code";
export const TOKEN_CITY_NAME = "city_name";
export const TOKEN_SRC_COUNTRY_CODE = "src_country_code";
export const TOKEN_SRC_COUNTRY_URL = "src_country_url";
export const TOKEN_SRC_COUNTRY_PLACE_CODE = "src_country_place_code";
export const TOKEN_ABOUT_SRC_COUNTRY = "about_src_country";
export const TOKEN_HI_SRC_COUNTRY_NAME = "hi_src_country_name";
export const TOKEN_AR_SRC_COUNTRY_NAME = "ar_src_country_name";
export const TOKEN_HI_DES_CITY_NAME = "hi_dest_city_name";
export const TOKEN_HI_COUNTRY_NAME = "hi_country_name";
export const TOKEN_COUNTRY_NAME = "country_name";
export const TOKEN_COUNTRY_CODE = "country_code";
export const TOKEN_COUNTRY_URL = "country_url";
export const TOKEN_AR_COUNTRY_NAME = "ar_country_name";
export const TOKEN_COUNTRY_PLACE_CODE = "country_place_code";
export const TOKEN_ABOUT_COUNTRY = "about_country";
export const TOKEN_HI_DES_COUNTRY_NAME = "hi_dest_country_name";
export const TOKEN_SRC_CITY_FLIGHT_CODE = "src_city_code";
export const TOKEN_SRC_CITY_PLACE_CODE = "src_place_code";
export const TOKEN_DES_CITY_PLACE_CODE = "dest_place_code";
export const TOKEN_DES_CITY_FLIGHT_CODE = "dest_city_code";
export const TOKEN_ABOUT_AIRLINE_TEXT = "about_airline_text";
export const TOKEN_AIRLINE_LOGO_URL = "airline_logo_url";
export const TOKEN_AIRLINE_BAGGAGE_INFO_HTML = "airline_baggage_info_html";
export const TOKEN_AIRLINE_CONTACT_INFO_HTML = "airline_contact_info_html";
export const TOKEN_AIRLINE_WEB_CHECKIN_HTML = "airline_web_checkin_html";
export const TOKEN_AIRLINE_INSURANCE_HTML = "airline_insurance_html";
export const TOKEN_AIRLINE_SERVICES_HTML = "airline_services_html";
export const TOKEN_H1_TITLE = "h1_title";
export const TOKEN_AIRLINE_CODE = "airline_code";
export const TOKEN_HINDI_PAGES_AIRLINE_URL_PHRASE = "hindi_pages_airline_url_phrase";
export const TOKEN_AIRPORT_NAME = "airport_name";
export const AIRPORT_NAME = " हवाई अड्डा";
export const TOKEN_AIRPORT_URL_PHRASE = "airport_url_phrase";
export const TOKEN_ABOUT_AIRPORT = "about_airport";
export const TOKEN_AIRPORT_DESCRIPTION = "airport_description";
export const TOKEN_ABOUT_AIRPORT_CITY = "about_airport_city";
export const TOKEN_AIRPORT_ADDRESS = "airport_address";
export const TOKEN_SRC_CITY_AIRPORT_ADDRESS = "src_airport_address";
export const TOKEN_DEST_CITY_AIRPORT_ADDRESS = "dest_airport_address";
export const TOKEN_AIRPORT_URL = "airport_url";
export const TOKEN_AIRPORT_LATITUDE = "airport_latitude";
export const TOKEN_AIRPORT_LONGITUDE = "airport_longitude";
export const TOKEN_AIRPORT_COUNTRY = "airport_country";
export const TOKEN_AIRPORT_CODE = "airport_code";
export const TOKEN_AIRPORT_CODE_LOWER_CASE = "airport_code_lower_case";
export const TOKEN_ABOUT_CITY = "about_city";
export const TOKEN_FLIGHT_CITY = "flight_city_code";
export const TOKEN_CITY_FLIGHT_CODE = "city_flight_code";
export const TOKEN_CITY_URL = "city_url";
export const TOKEN_FLIGHT_CITY_URL = "flight_city_url";
export const TOKEN_CITY_URL_PHRASE = "city_url_phrase";
export const TOKEN_CITY_PLACE_CODE = "city_place_code";
export const TOKEN_LOCUS_CITY_CODE = "locus_city_code";
export const TOKEN_AR_DES_COUNTRY_NAME = "ar_dest_country_name";
export const TOKEN_DES_COUNTRY_CODE = "dest_country_code";
export const TOKEN_DES_COUNTRY_URL = "dest_country_url";
export const TOKEN_DES_COUNTRY_PLACE_CODE = "dest_country_place_code";
export const TOKEN_ABOUT_DES_COUNTRY = "about_dest_country";
export const TOKEN_AR_CITY_NAME = "ar_city_name";
export const TOKEN_AR_SRC_CITY_NAME = "ar_src_city_name";
export const TOKEN_AR_DES_CITY_NAME = "ar_dest_city_name";
export const TOKEN_PNR_STATUS_URL = "pnr_status_url";
export const TOKEN_ROAD_DISTANCE = "road_distance";
export const TOKEN_SRC_LOCUS_CODE = "src_locus_code";
export const TOKEN_DES_LOCUS_CODE = "dest_locus_code";

export const CURRENT_TEMPLATE = "currentTemplate";
export const TOKEN_ROUTE_URL_PATH = "route_url_path";
export const SRC_AIRPORT = "srcAirport";
export const DEST_AIRPORT = "destAirport";
export const JRNY_SRC_CITY = "jrnySrcCity";
export const SRC_CITY = "srcCity";
export const JRNY_DEST_CITY = "jrnyDestCity";
export const DEST_CITY = "destCity";
export const IF_SRC_CITY = "if_src_city";
export const IF_COUNTRY = "if_country";
export const IFCITY = "ifCity";
export const IFAIRPORT = "ifAirport";
export const IF_AIRPORT_LIST = "ifAirportList";
export const IF_DEST_CITY = "if_dest_city";
export const IF_COUNTRY_FOLDERS = "ifCountryFolders";
export const IF_SRC_COUNTRY = "if_src_country";
export const IF_DEST_COUNTRY = "if_dest_country";
export const IF_SRC_CITY_AIRPORT_LIST = "ifSrcCityAirportList";
export const IF_DEST_CITY_AIRPORT_LIST = "ifDestCityAirportList";
export const IFCOUNTRY = "ifCountry";
export const LANGUAGE = "language";
export const LANG = "lang";
export const CRID = "crId";
export const DEFAULT_CCDE = "IN";
export const IS_INTL = "isIntl";
export const BLOCKS = "blocks";
export const FLIGHTS_NODE = "flightsNode";
export const FLIGHTS_NODE_TABLE = "flights_node";
export const HINDI_URL_CHECK = "flights/hi/";
export const ARABIC_URL_CHECK = "united_arab_emirates/ar/";
export const BASE_URL_DOM_ABSOLUTE = "https://www.makemytrip.com/flights/";
export const BASE_URL_GI_DOM_ABSOLUTE = "https://www.goibibo.com/flights/";
export const BASE_URL_GCC_ABSOLUTE =
  "https://www.makemytrip.com/international-flights/united_arab_emirates/";
export const BASE_URL_INTL_ABSOLUTE = "https://www.makemytrip.com/international-flights/";
export const BASE_URL_GI_INTL_ABSOLUTE = "https://www.goibibo.com/international-flights/";
export const INTL_FLIGHT_LOGO_URL =
  "//imgak.mmtcdn.com/air/pwa/dist/assets/img/airline-logos/sm{airlineCode}.gif?v=12";
export const DATE_FORMAT = "dd-MM-yyyy";
export const DATE_FORMAT_PLUS_2 = "D2_dd-MM-yyyy";
export const DATE_FORMAT_PLUS_D2 = "D2_MMddyyyy";
export const DATE_FORMAT_PLUS_4 = "D4_dd-MM-yyyy";
export const DATE_FORMAT_YYYYMMDD = "yyyyMMdd";
export const OFFERS_CAROUSEL_BLOCK_IF = "offers_carousel_block_IF";
export const OFFERS_CAROUSEL_BLOCK_DF = "offers_carousel_block_DF";
export const RKEYURL =
  "ccde={ccde}&itineraryId={itineraryId}&rKey={rKey}&crId={crId}&cur=INR&openFF=undefined&xflt={xflt}";
export const SHOW_MORE_BUTTON = "showMoreButton";
export const AIRLINE_P1_INTL_ROUTES = "p1IntlRoutes";
export const AIRLINE_IMG_URL_PWA =
  "//imgak.mmtcdn.com/flights/assets/media/mobile/common/hdpi/{airline_code}.png";
export const AIRLINE_IMG_URL_DESKTOP =
  "//imgak.mmtcdn.com/flights/assets/media/dt/common/icons/{airline_code}.png";
export const IF_ROUTE_CHEAP_FLIGHTS = "ifcheapFlights";
export const DOM_TOP_AIRLINE_LIST = "domTopAirlineList";
export const INTL_TOP_AIRLINE_LIST = "INTL_TOP_AIRLINE_LIST";
export const AIRLINE_P2_DOM_ROUTES = "p2DomRoutes";
export const AIRLINE_P2_INTL_ROUTES = "p2IntlRoutes";
export const DOM_TOP_ROUTE_DATA = "domTopRouteData";
export const INTL_ROUTES_IF_CITY_BLOCK = "intlRoutesIfCityBlock";
export const CITY_CITY = "CITY-CITY";
export const CITY_COUNTRY = "CITY-COUNTRY";
export const INTL_AIRLINE_ROUTES = "intl_airlines_route";
export const CHEAP_FARE_API = "cheapFareApi";
export const IF_ROUTE_TOP_FLIGHTS = "ifTopFlights";
export const IF_ROUTE_LIST_WITH_CONDITION = "ifRouteListWithCondition";
export const INDIA_COUNTRY_CODE = "IN";
export const R2D2_RESPONSE_KEY_FLIGHTS = "fl";
export const R2D2_RESPONSE_KEY_FROM_CITY = "fc";
export const R2D2_RESPONSE_KEY_TO_CITY = "tc";
export const SEO_URL = "seoUrl";
export const IF_AIRLINE_LIST = "if_airline_list";
export const BLOCKS_DATA = "blocksData";
export const BASE_URL_OBT = "international-flights/";
export const BASE_URL_DOM = "flights/";
export const PATH_VAR_SRC = "src";
export const PATH_VAR_DEST = "dest";
export const PATH_VAR_AIRLINE = "pathVarAirline";
export const ENTITY_TYPE_CITY = "City";
export const ENTITY_TYPE_INTL_AIRLINE = "IntlAirline";
export const ENTITY_TYPE_INTL_CITY = "IntlCity";
export const FLIGHTS_LOB = "flights";
export const INTERNATIONAL_FLIGHTS_LOB = "international_flights";
export const ENTITY_TYPE_INTL_AIRPORT = "IntlAirport";
export const PATH_VAR_INTL_CITY = "pathVarIntlCity";
export const ENTITY_TYPE_AIRLINE_REDIRECTION = "Airline";
export const PATH_VAR_CITY = "pathVarCity";
export const PATH_VAR_COUNTRY = "pathVarCountry";
export const PATH_VAR_INTL_AIRLINE = "pathVarIntlAirline";
export const PATH_VAR_CITY_CODE = "pathVarCityCode";
export const PATH_VAR_INTL_AIRPORT = "pathVarIntlAirportUrlPhrase";
export const PATH_VAR_INTL_COUNTRY = "pathVarIntlCountry";
export const PATH_VAR_INTL_CITY_COUNTRY_SRC = "pathVarIntlCityCountrySrc";
export const PATH_VAR_INTL_CITY_COUNTRY_DEST = "pathVarIntlCityCountryDest";
export const PATH_VAR_INTL_AIRPORT_URL_PHRASE = "pathVarIntlAirportUrlPhrase";
export const PATH_VAR_INTL_AIRPORT_CODE = "pathVarIntlAirportCode";
export const PATH_VAR_INTL_SRC_CITY = "pathVarIntlSrcCity";
export const PATH_VAR_INTL_DEST_CITY = "pathVarIntlDestCity";
export const DF_ROUTE_CHEAP_FLIGHTS = "dfcheapFlights";

export const URL_NEW_FLIGHT_CAB = "newFlightCabUrl";
export const AIRLINE_BAGGAGE_TEMPLATE = "airline_baggage_template";
export const AIRLINE_FLIGHT_SCHEDULE_TEMPLATE = "airline_flight_schedule_template";
export const AIRLINE_WEBCHECKIN_TEMPLATE = "airline_webcheckin_template";
export const DAILY_DEALS_COUCH_KEY_NAME = "daily_deals";
export const DAILY_DEALS_OFFER_DATA_FIELD_LOB = "field_lob";
export const DAILY_DEALS_OFFER_DATA_FIELD_VID = "nid";
export const DAILY_DEALS_OBJECT = "daily_deals";

export const MOVED_PERMANENTLY = 301;
export const NOT_FOUND = 404;
export const PERMANENT_REDIRECT = 308;
export const OK = 200;
export const TEMPORARY_REDIRECT = 307;
export const INTERNAL_SERVER_ERROR = 500;

export const AIRPORT_MAPPED_TO_COUNTRY = "airportMappedToCountry";
export const MYBIZ_LOGIN_MODAL_DATA = {
  heading: {
    defaultMessage: "<b>Join myBiz</b> to Unlock Benefits",
    id: "",
  },
  offers: [
    {
      defaultMessage: "<b>Free Cancellation</b> on <b>Hotel</b> & <b>Flight</b> bookings",
      imageClassName: "myBizDiscountIcon",
      id: "",
    },
    {
      defaultMessage: "<b>GST Invoice Assured</b> Hotels",
      imageClassName: "myBizHotelIcon",
      id: "",
    },
    {
      defaultMessage: "<b>Free Date Change</b> and <b>Free Seats & Meal</b> in Flights",
      imageClassName: "myBizGstIcon",
      id: "",
    },
  ],
};

export const POST_LOGIN_RDRCT_URL_SSN_STRG_KEY = "postLoginRedirectURL";

export const PROFILE_TYPE = {
  BUSINESS: "BUSINESS",
  PERSONAL: "PERSONAL",
  CTA: "CTA",
};

export const YOLO_PERSUASION = {
  header: "Sign in for a faster booking experience",
  subHeader: "Grab the BEST deal for your flight booking!",
};

export const BASE_TEMPLATES = [
  IF_AIRLINE_INDEX_TEMPLATE,
  IF_AIRLINE_TEMPLATE,
  IF_AIRPORT_TEMPLATE,
  IF_CITY_AIRLINE_INDEX_TEMPLATE,
  IF_CITY_AIRLINE_TEMPLATE,
  IF_CITY_AIRPORT_INDEX_TEMPLATE,
  IF_CITY_CITY_AIRLINE_INDEX_TEMPLATE,
  IF_CITY_CITY_INDEX_TEMPLATE,
  IF_CITY_CITY_TEMPLATE,
  IF_CITY_CONTINENT_TEMPLATE,
  IF_CITY_COUNTRY_INDEX_TEMPLATE,
  IF_CITY_COUNTRY_TEMPLATE,
  IF_CITY_INDEX_TEMPLATE,
  IF_CITY_TEMPLATE,
  IF_COUNTRY_CITY_TEMPLATE,
  IF_DISTANCE_TEMPLATE,
  IF_FARE_CALENDAR_TEMPLATE,
  IF_FLIGHT_SCHEDULE_TEMPLATE,
  IF_OFFER_TEMPLATE,
  IF_ROUTE_AIRLINE_TEMPLATE,
];

export const DOMAIN_FOR_COUNTRY = {
  AE: "ae",
  OM: "ae",
  KW: "ae",
  SA: "ae",
  BH: "ae",
  QA: "ae",
  US: "us",
};

export const TYPECLASSES = {
  ADULT: "numAdult",
  CHILDREN: "numChildren",
  INFANT: "numInfant",
  TRAVEL_CLASS: "cabinClass",
};
export const ADULTS = [1, 2, 3, 4, 5, 6, 7, 8, 9];
export const CHILDREN = [0, 1, 2, 3, 4, 5, 6];
export const TRAVEL_CLASS = [
  { label: "Economy", value: "E", type: "Economy" },
  { label: "Premium Economy", value: "PE" },
  { label: "Business", value: "B" },
  { label: "First Class", value: "F" },
];
export const TRIP_TYPE = {
  ONWARDS: "O",
  ROUND_TRIP: "R",
};
export const TRIP_TYPE_DD_OPTIONS = [
  { label: "One Way", value: TRIP_TYPE.ONWARDS, O: "One Way" },
  { label: "Round Trip", value: TRIP_TYPE.ROUND_TRIP, R: "Round Trip" },
];
export const NEW_TRIP_TYPE = {
  O: "One Way",
  R: "Round Trip",
};

export const DATE = {
  SEPARATOR: "/",
};

export const polyglotTags = {
  dt: ["MMT_FLIGHTS_UI_DT"],
  pwa: ["MMT_FLIGHTS_UI_PWA"],
};

export const YEARS = (() => {
  const currentYear = new Date().getFullYear();
  const years = [];
  let startYear = 1900;

  while (startYear <= currentYear) {
    years.push(startYear++);
  }
  return years;
})();

export const LANGUAGE_SUPPORT = {
  en: "eng",
  ar: "ara",
  hi: "hin",
};

export const GI_LANGUAGE_SUPPORT = {
  en: "eng",
  hi: "hin",
};

export const CURRENCY_CODES_FOR_COUNTRY = {
  AE: "AED",
  OM: "AED",
  KW: "AED",
  SA: "AED",
  BH: "AED",
  QA: "AED",
  US: "USD",
  IN: "INR",
};

export const CCDE_SUPPORT = {
  bahrain: "AE",
  kuwait: "AE",
  oman: "AE",
  qatar: "AE",
  saudi_arabia: "AE",
  united_arab_emirates: "AE",
  united_states: "US",
};

export const ismPageServicePageType = {
  routeAirlinePage: true,
  routePage: true,
  routePage_city_country_pwa: true,
  routePage_country_city_pwa: true,
  fareCalendarPage: true,
  flightSchedulePage_united_arab_emirates: true,
  flightSchedulePage_PWA: true,
  distancePage_pwa: true,
  flightSchedulePageGI: true,
  flightSchedulePageGI_PWA: true,
};

export const flightsIsmDTNewPageType = {
  flightSchedulePageGI: true,
  flightSchedulePageGI_PWA: true,
  routeAirlinePage: true,
  routePage: true,
  routePage_city_country_pwa: true,
  routePage_country_city_pwa: true,
  fareCalendarPage: true,
  flightSchedulePage_united_arab_emirates: true,
  flightSchedulePage_PWA: true,
};

export const ismFareFinderServicePageType = {
  flightSchedulePage: true,
};

export const fareFinderDTPageType = {
  flightSchedulePage: true,
};

export const noCommonHeaderPageType = {
  flightSchedulePage: false,
  distancePage_enableJquery: false,
  distancePage_enableJqueryGI: true,
  routeAirlinePage: true,
  routePage: true,
  routePage_city_country_pwa: true,
  routePage_country_city_pwa: true,
  fareCalendarPage: true,
  flightSchedulePage_united_arab_emirates: true,
  flightSchedulePage_PWA: true,
  cityPage: true,
  routePage_city_country: true,
  offerPage: true,
  airlineIndexPage: true,
  airlinePage: true,
  staticPage: true,
  indexBaggagePage: true,
  indexWebCheckinPage: true,
  indexSchedulePage: true,
  fromPage: true,
  toPage: true,
  cityAirportPage: true,
  cityAirlinePage: true,
  flightSchedulePageGI: true,
  flightSchedulePageGI_PWA: true,
  senior_citizens: true,
  armed_forces: true,
  cheap_flights: true,
};

export const ismPageService2PageType = {
  distancePage_enableJquery: true,
  distancePage_enableJqueryGI: true,
};

export const ismDestinationPickerPageType = {
  distancePage_destPickerDT: true,
  routePage_city_country: true,
};

export const destinationPickerDTPageType = {
  routePage_city_country: true,
};

export const flightIsm2PageType = {
  distancePage_enableJquery: true, 
  distancePage_enableJqueryGI: true,
};

export const pageServiceType = {
  cityPage: true,
  cityAirlinePage: true,
  airlinePage: true,
  airlineIndexPage: true,
  cityAirportPage: true,
  indexBaggagePage: true,
  indexSchedulePage: true,
  indexWebCheckinPage: true,
  fromPage: true,
  toPage: true,
  senior_citizens: true,
  armed_forces: true,
  cheap_flights: true,
};

export const flightsStaticPageType = {
  cityPage: true,
  cityAirlinePage: true,
  airlinePage: true,
  airlineIndexPage: true,
  cityAirportPage: true,
  staticPage: true,
  indexBaggagePage: true,
  indexSchedulePage: true,
  indexWebCheckinPage: true,
  fromPage: true,
  toPage: true,
  senior_citizens: true,
  armed_forces: true,
  cheap_flights: true,
};

export const staticTemplatePageType = {
  staticPage: true,
};

export const COUNTRY_CODE_MAP = {
  IN: "in",
  AE: "ae",
  US: "us",
  SA: "sa",
  OM: "om",
  KW: "kw",
};

export const AIRLINE_TO_PNR_MAP = {
  indigo: "https://www.goindigo.in/",
  air_india: "https://www.airindia.com/",
  spicejet: "https://book.spicejet.com/RetrieveBooking.aspx",
  air_india_express: "https://www.airindiaexpress.com/mybooking",
  vistara: "https://www.airvistara.com/in/en",
};

export const MAPPING_API =
  "http://mapi.mmt.mmt/mobile-core-api-web/api/config/?brand=mmt&profile=seo";

export const xdmPageTypeHelper = {
  routePage: "route",
  airlinePage: "airline",
  cityPage: "city",
  distancePage: "distance",
  fareCalendarPage: "fare_calender",
  flightSchedulePage: "flight_schedule",
  flightSchedulePageGI: "flight_schedule",
  flightSchedulePageGI_PWA: "flight_schedule",
  flightSchedulePage_united_arab_emirates: "flight_schedule",
  flightSchedulePage_PWA: "flight_schedule",
  routeAirlinePage: "airline_route",
  airlineIndexPage: "airline_index",
  cityAirportPage: "city_airport",
  cityAirlinePage: "city_airline",
  offerPage: "offers",
  staticPage: "static",
  fromPage: "city",
  toPage: "city",
  indexBaggagePage: "static",
  indexSchedulePage: "static",
  indexWebCheckinPage: "static",
  routePage_city_country: "city_country",
  routePage_city_country_pwa: "city_country",
  routePage_country_city_pwa: "country_city",
  airportPage: "airport",
  cityCountryIndexPage: "city_country_index",
  indexLandingPage: "index_landing",
  indexCityAirlinePage: "index_city_airline",
  indexCityPage: "index_city",
  indexCityRoutePage: "index_city_route",
  indexCityNamePage: "index_city_name",
  senior_citizens: "senior_citizens",
  armed_forces: "armed_forces",
  cheap_flights: "static",
};
